<!-- bbs > 모니터링 행동관찰 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="tit-group ty01 mo-home-add">
        <BtnIcon class="btn-ico-home" @click="utils.movePage('/actionManagement')"></BtnIcon>
        <h4 class="tit">{{monitoringInfo.monitoringTitle}}</h4>
        <div class="alert-group" v-if="auditTargetCnt > 0">
          <v-alert :text="t('message.auditInProgress')"></v-alert>
        </div>
      </div>
      <div class="nodata-group" v-if="!isActiveMonitoring">
        <div class="txt">{{t('message.monitoringEnded')}}</div>
      </div>
      <div class="tab-group ty01" v-if="isActiveMonitoring">
        <v-tabs
          v-model="tab"
        >
          <v-tab value="tabCont1">{{t('message.behaviorObservation')}}</v-tab>
          <v-tab value="tabCont2">{{t('message.safetyTalk')}}</v-tab>
        </v-tabs>
      </div>
      <div class="content-box bg-none" v-if="isActiveMonitoring">
        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="tabCont1">
            <div class="form-group col-ty">
              <!--form-row-->
              <div class="form-row ty03">
                <div class="txt-tit ty02">
                  <c-tooltip :TooltipText="t('message.adminManagedItemNotice')"/>
                  {{t('message.location')}}
                </div>
                <div class="row">
                  <Select v-bind="placeTab1Select" v-model="place"/>
                </div>
              </div>
            </div>
            <div class="list-group2 ty01">
              <!--list-->
              <div class="list" v-for="(item, i) in monitoringItems" :key="i">
                <div class="row1">
                  <div class="num">{{i+1}}</div>
                  <div class="txt">{{item.behaviorTitle}}</div>
                  <div class="right-area">
                    <div class="check-group ty01">
                      <v-checkbox :label="t('message.notApplicable')"
                                  v-model="item.etcYn"
                                  true-value="Y" false-value="N"
                                  @update:modelValue="(val) => { if (val === 'Y') {item.answerData = '';item.comment='';item.comments=[];} }"></v-checkbox>
                    </div>
                    <c-btnText01 :btnText="t('message.goToSafetyTalk')" class="ty03" @click.prevent="onClickTimeline(item)"/>
                  </div>
                </div>
                <div class="row2">
                  <div class="radio-group2">
                    <v-radio-group v-model="item.answerData" @change.stop.prevent="onClickReg('Y')" :disabled="item.etcYn=='Y'">
                      <v-radio :label="t('message.safe')" value="1"></v-radio>
                      <v-radio :label="t('message.unsafe')" value="0"></v-radio>
                    </v-radio-group>
                    <div class="error-msg" v-if="item.essentialYn == 'Y' && !item.answerData && isAfterSubmit && item.etcYn != 'Y'">{{t('message.requiredField')}}</div>
                  </div>
                  <div class="inner" v-if="item.answerData === '0'">
                    <!--다중체크 스타일-->
                    <div class="check-group3" v-if="item.multiYn == 'Y'" @change.stop.prevent="onClickReg('Y')" :disabled="item.etcYn=='Y'">
                      <v-checkbox v-for="(item2, i2 ) in item.behaviorComments"
                                  v-model="item.comments"
                                  :label="item2.commentTitle"
                                  :value="item2.commentTitle+','+item2.idx">
                      </v-checkbox>
                    </div>
                    <div class="radio-group3" v-if="item.multiYn != 'Y'">
                      <v-radio-group v-model="item.comment" @change.stop.prevent="onClickReg('Y')" :disabled="item.etcYn=='Y'">
                        <v-radio v-for="(item2, i2 ) in item.behaviorComments"
                                 :key="i2"
                                 :label="item2.commentTitle"
                                 :value="item2.commentTitle+','+item2.idx"
                                 :disabled="item.etcYn=='Y'">
                        </v-radio>
                      </v-radio-group>
                    </div>
                    <c-input :placeholder="t('message.enterAdditionalComments')" v-model="item.commentEtc" @focusin="onInputEtc($event, i)" :name="'commentEtc'+i" :disabled="item.etcYn=='Y'"></c-input>
                  </div>
                </div>
              </div>
              <!--list-->
            </div>
            <div class="bottom-btn-group ty02">
              <div class="wl">
              </div>
              <div class="wr">
                <c-btn01 :btnText="t('message.submit')" @click.prevent.stop="onClickReg('N')" />
              </div>
            </div>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont2">
            <div class="dropdown-group2">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel v-for="(item, i) in timelineItems" :key="i">
                  <v-expansion-panel-title>{{t('message.safetyTalk')}}{{i+1}}
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div class="form-group col-ty">
                      <div class="tit-group ty02">
                        <div class="tit02">{{t('message.basicInfo')}}</div>
                        <div class="wr">
                          <c-btnLine01 :btnText="t('message.delete')" class="ty04" @click.stop="onClickDeleteTimeline(item)"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row">
                        <div class="txt-tit">{{t('message.type')}}</div>
                        <div class="row">
                          <div class="radio-group">
                            <v-radio-group v-model="item.type" @update:modelValue="() => onClickTimelineReg('Y', i+1)">
                              <v-radio value="1" color="indigo" :label="t('message.correctiveSafetyTalk')" class="r-size01"></v-radio>
                              <v-radio value="2" color="indigo" :label="t('message.supportiveSafetyTalk')"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.type=='1'">
                        <div class="txt-tit">
                          {{t('message.correctiveActionRequired')}}
                          <c-tooltip :TooltipText="t('message.assignCorrectiveActionDescription')"/>
                        </div>
                        <div class="row">
                          <div class="radio-group">
                            <v-radio-group v-model="item.actionYn" @update:modelValue="() => onClickTimelineReg('Y', i+1)">
                              <v-radio value="N" color="indigo" :label="t('message.notNecessary')" class="r-size01"></v-radio>
                              <v-radio value="Y" color="indigo" :label="t('message.necessary')"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.actionYn=='Y' || item.type=='2'">
                        <div class="txt-tit ty03">
                          {{t('message.targetPerson')}}
                        </div>
                        <div class="row">
                          <div class="radio-group">
                            <v-radio-group v-model="item.targetType" @update:modelValue="() => onClickTimelineReg('Y', i+1)">
                              <v-radio value="1" color="indigo" :label="t('message.noSpecificDesignation')" class="r-size01"></v-radio>
                              <v-radio value="2" color="indigo" :label="t('message.department')" @click="onChangeTarget(item, 'dept', i+1)"></v-radio>
                              <v-radio value="3" color="indigo" :label="t('message.members')" @click="onChangeTarget(item, 'member', i+1)"></v-radio>
                            </v-radio-group>
                          </div>
                          <p class="txt04" v-if="item.targetType == '1'">{{t('message.noTarget')}}</p>
                          <p class="txt04" v-if="item.targetType == '2'">{{ item.targetDeptName }}</p>
                          <p class="txt04" v-if="item.targetType == '3'">{{ item.targetMemberName }}</p>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.actionYn=='Y' && item.type == '1'">
                        <div class="txt-tit">
                          {{t('message.actionDeadline')}}
                        </div>
                        <div class="row">
                          <c-InputDate v-model="item.goalDate" :enableTimePicker="false" class="size02" readonly=""/>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-ty line-ty">
                      <div class="tit-group">
                        <div class="tit02">{{t('message.detailedInfo')}}</div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.type=='1'">
                        <div class="txt-tit">{{t('message.monitoringBehavior')}}</div>
                        <div class="row">
                          <Select v-bind="behaviorSelect" v-model="item.behaviorIdx"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.type=='1'">
                        <div class="txt-tit">{{t('message.location')}}</div>
                        <div class="row">
                          <Select v-bind="placeTab1Select" v-model="item.place"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row">
                        <div class="txt-tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}<span class="imp">*</span></div>
                        <div class="row">
                          <c-Input :placeholder="item.type=='1'?t('message.writeSituationClearly'):t('message.writePraiseReasonSpecifically')" v-model="item.situation" @focusout="onClickTimelineReg('Y', i+1)" :name="'situation'+(i+1)"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.type=='1'">
                        <div class="txt-tit">{{t('message.cause')}}</div>
                        <div class="row">
                          <c-Input :placeholder="t('message.writeCauseBasedOnConversation')" v-model="item.cause" @focusout="onClickTimelineReg('Y', i+1)" :name="'cause'+(i+1)"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row" v-if="item.type=='1'">
                        <div class="txt-tit">{{t('message.correctiveActionDetails')}}</div>
                        <div class="row">
                          <c-Input :placeholder="t('message.writeCorrectiveActionSpecifically')" v-model="item.action" @focusout="onClickTimelineReg('Y', i+1)" :name="'action'+(i+1)"/>
                        </div>
                      </div>
                      <!--form-row-->
                      <div class="form-row">
                        <div class="txt-tit ty03" v-html="t('message.imageUploadMax5')"></div>
                        <div class="row">
                          <InputImgAdd :seq="i+1" @upload="onClickTimelineReg('Y', i+1)"/>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div class="bottom-btn-group ty02">
              <div class="wl">
              </div>
              <div class="wr">
                <c-btnLine01 :btnText="t('message.addSafetyTalk')" @click="onClickAddTimeline"/>
                <c-btn01 :btnText="t('message.submit')" @click.prevent.stop="onClickReg('N')"/>
              </div>
            </div>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </div>
    <!--
    <div class="bottom-btn-group">
      <div class="wl">
      </div>
      <div class="wr">
        <c-btnLine01 :btnText="'안전대화 추가'"/>
        <c-btn01 :btnText="t('message.submit')"/>
      </div>
    </div>
    -->
  </div>
  <DialogDept
    v-model="deptDialogModel"
    :mode="'single'"
    :popTitle="t('message.department')"
    @close="deptDialogModel=false"
    @confirm="confirmDeptDialog"/>
  <DialogTargetAdd
    v-model="memberDialogModel"
    @close="memberDialogModel=false"
    @confirm="confirmMemberDialog"/>
  <!--popup: 임시저장 불러오기-->
  <c-dialog v-model="dialogTempModel"
            v-bind="dialogTempBind"
            @close="dialogTempModel=false"
            @confirm="confirmTemp"
  />
  <c-dialog v-model="dialogCopyModel"
            v-bind="dialogCopyBind"
            @close="dialogCopyModel=false"
            @cancel="confirmCopy('cancel')"
            @confirm="confirmCopy('confirm')"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, computed, watch, onMounted} from 'vue';
import {useCommonStore} from "@/store/common";
import BbsService from "@/services/bbs.service";
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import * as yup from "yup";
import {useForm} from "vee-validate";
const { t } = useI18n();

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const deptDialogModel = ref(false)
const memberDialogModel = ref(false)
const tab = ref('tabCont1')
const monitoringItems:any = ref([])
const place = ref('')
const auditTargetCnt = ref(0)
const monitoringInfo:any = ref({})
const dialogTempModel = ref(false)
const timelineItems:any = ref([])
const panel = ref([0])
const dialogCopyModel = ref(false)
const selectedItem:any = ref(null)
const selectedBehavior:any = ref(null)
const isActiveMonitoring = ref(true)
const isAfterSubmit = ref(false)

//ui
const placeTab1SelectAdd = ref([])
const placeTab1Select = computed(() =>( {items: [{name: t('message.notSelected'), value: ''}, ...placeTab1SelectAdd.value]} ))
const behaviorSelectAdd = ref([])
const behaviorSelect = computed(() =>({items: [{name:t('message.notSelected'), value: ''}, ...behaviorSelectAdd.value]} ))
//const placeTab2Select = ref({items: [{name: t('message.notSelected'), value: ''}]})
let dialogTempBind = {
  dialogTit: t('message.loadDraft'),
  dialogText: '',
  btn1Text: t('message.loadData'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const dialogCopyBind = {
  dialogTit: t('message.loadData'),
  dialogText: t('message.loadPreviousSafetyTalkInfo'),
  btn1Text: t('message.loadData'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//hook
onMounted(() => {
})

//function
const onClickTimeline=(item)=>{
  selectedBehavior.value = item
  tab.value='tabCont2'
}

const onChangeTarget=(item,type, tempSeq)=>{
  if(type=='dept'){
    let companyIdx = localStorage.getItem('companyIdx')
    storeRef.popupIdx.value = companyIdx
    storeRef.popupType.value = type
    selectedItem.value = item
    selectedItem.value.tempSeq = tempSeq
    deptDialogModel.value=true
  }
  else if(type=='member'){
    selectedItem.value = item
    selectedItem.value.tempSeq = tempSeq
    memberDialogModel.value=true
  }
}

const confirmDeptDialog=(params)=>{
  deptDialogModel.value=false
  if(params !== false) {
    let resultName = []
    let resultIdxs = []
    _.forEach(params, (obj, key)=> {
      resultName.push(obj.treeName)
      resultIdxs.push(obj.idx)
    });
    selectedItem.value.targetDeptName = resultName[0]
    selectedItem.value.targetDeptIdx = resultIdxs[0]
    onClickTimelineReg('Y', selectedItem.value.tempSeq)
  }
}

const confirmMemberDialog=(params)=> {
  memberDialogModel.value=false
  if(!utils.isEmpty(params)){
    selectedItem.value.targetMemberName = params.memberInfo
    selectedItem.value.targetMemberIdx = params.idx
    onClickTimelineReg('Y', selectedItem.value.tempSeq)
  }
}

const confirmTemp=()=>{
  _.forEach(monitoringItems.value, (behaviorItem, key)=> {
    _.forEach(monitoringInfo.value.monitoringAnswers, (answerItem, key2)=> {
      if(answerItem.isTemp == 'Y') {
        place.value = answerItem.placeIdx==0?'':answerItem.placeIdx
        _.forEach(answerItem.answers, (answerRowItem, key3)=> {
          if (answerRowItem.behaviorIdx == behaviorItem.idx) {
            //응답값 셋팅
            behaviorItem.answerData = answerRowItem.answerData
            //코멘트 셋팅
            if(behaviorItem.multiYn == 'Y'){
              const commentTitles = answerRowItem.comment?.split(',') || [];
              const commentIdxs = answerRowItem.commentIdx?.split(',') || [];
              const mergedComments = commentTitles.map((title, idx) => {
                return `${title},${commentIdxs[idx] || ''}`
              })
              behaviorItem.comments = mergedComments;
            }
            else {
              behaviorItem.comment = answerRowItem.comment+','+answerRowItem.commentIdx
            }
          }
        })
      }
    })
  })
}

const onClickReg=(isTemp)=>{
  //종료된 모니터링 체크
  let endDate = dayjs(monitoringInfo.value.endDate).format('YYYY-MM-DD')
  const today = dayjs().startOf('day');
  if(today.isAfter(endDate)){
    snackText.value = t('message.monitoringEnded')
    snackbar.value = true
    return
  }

  //완료여부 체크
  let answerCnt = 0
  if(monitoringInfo.value.duplicateYn != 'Y'){
    _.forEach(monitoringInfo.value.monitoringAnswers, (val, key)=> {
      if(val.isTemp == 'N'){
        if(isTemp == 'N') {
          answerCnt++
        }
      }
    })
  }
  if(answerCnt >= monitoringInfo.value.periodCnt) {
    snackText.value = t('message.observationCompleted')
    snackbar.value = true
    return
  }

  //중복불가능이고 응답있으면 불가능
  if(isTemp == 'N' && monitoringInfo.value.duplicateYn == 'N'){
    const answerCnt = _.filter(monitoringInfo.value.monitoringAnswers, { isTemp: 'N' }).length
    if(monitoringInfo.value.periodCnt <= answerCnt) {
      snackText.value = t('message.observationCompleted')
      snackbar.value = true
      return
    }
  }

  //필수행동이 있을경우
  //const unEssentialList = _.filter(monitoringItems.value, item=>item.essentialYn == 'Y' && !item.answerData && item.etcYn != 'Y')
  //if(unEssentialList.length > 0 && (tab.value == 'tabCont1' || (tab.value == 'tabCont2' && answeredList.length > 0))){
  const unEssentialList1 = _.filter(monitoringItems.value, item=>item.essentialYn == 'Y' && !item.answerData && item.etcYn != 'Y')
  const unEssentialList2 = _.filter(monitoringItems.value, item=>item.essentialYn == 'Y' && !item.answerData && item.etcYn != 'Y' && monitoringInfo.value.timelineYn == 'Y')
  //const answeredList = _.filter(monitoringItems.value, item=>item.answerData)
  if(isTemp == 'N' && (unEssentialList1.length > 0 && tab.value == 'tabCont1') || (unEssentialList2.length > 0 && tab.value == 'tabCont2')){
    isAfterSubmit.value = true
    if(tab.value == 'tabCont2')
      tab.value = 'tabCont1'
    return
  }

  //임시저장아니고 타임라인필수면 탭이동
  if(isTemp == 'N' && monitoringInfo.value.timelineYn == 'Y'){
    if(timelineItems.value.length <= 0) {
      snackText.value = t('message.safetyTalkRequired')
      snackbar.value = true
      tab.value = 'tabCont2'
      return
    }
  }

  //타임라인 필수데이터 체크
  if(isTemp == 'N'){
    const emptyList = _.filter(timelineItems.value, item=>_.isEmpty(item.situation))
    if((timelineItems.value.length >= 1 && emptyList.length > 0)) {
      snackText.value = t('message.requiredField')
      snackbar.value = true
      tab.value = 'tabCont2'
      return
    }
  }

  //타임라인체크
  let targetCheck = false
  _.forEach(timelineItems.value, (item, key)=> {
    if((item.targetType == '2' && utils.isEmpty(item.targetDeptName)) || (item.targetType == '3' && utils.isEmpty(item.targetMemberName)))
      targetCheck = true
  })
  if(targetCheck){
    snackText.value = t('message.noRecipientSelected')
    snackbar.value = true
    return
  }

  if(viewIdx) {
    let answers = []
    _.forEach(monitoringItems.value, (item, key)=> {
      let tempObj = {}
      tempObj['behaviorIdx'] = item.idx
      tempObj['behaviorType'] = item.behaviorType
      tempObj['answerData'] = item.answerData
      tempObj['etcYn'] = item.etcYn
      //코멘트 중복여부
      if(item.multiYn == 'Y' && item.answerData==0 && item.etcYn!='Y'){
        const parsed = (Array.isArray(item.comments) ? item.comments : []).map(c => {
          const [title, idx] = c.split(',')
          return { title, idx: Number(idx) }
        })
        const sorted = _.sortBy(parsed, 'idx')
        const titles = sorted.map(c => c.title)
        const idxs = sorted.map(c => c.idx)

        if (!utils.isEmpty(item.commentEtc)) {
          titles.push(item.commentEtc)
          idxs.push(0)
        }
        tempObj['comment'] = titles.join(',')
        tempObj['commentIdx'] = idxs.join(',')
      }
      else {
        if (!utils.isEmpty(item.commentEtc)) {
          tempObj['comment'] = item.commentEtc
          tempObj['commentIdx'] = 0
        } else {
          if (item.comment) {
            tempObj['comment'] = item.comment.split(',')[0]
            tempObj['commentIdx'] = item.comment.split(',')[1]
          }
        }
      }
      tempObj['isTemp'] = isTemp
      answers.push(tempObj)
    })

    const user = JSON.parse(localStorage.getItem('user'))
    const companyIdx = localStorage.getItem('companyIdx')
    let params = {
      monitoringIdx: viewIdx,
      periodSeq: monitoringInfo.value.periodSeq!=0?monitoringInfo.value.periodSeq:1,
      memberIdx: user.memberIdx,
      companyIdx: companyIdx?companyIdx:user.companyIdx,
      deptIdx: user.deptIdx,
      posIdx: user.posIdx,
      isTemp: isTemp,
      placeIdx: place.value,
      answers: answers,
    }

    BbsService.insertAnswer(params).then(
      (response) => {
        if (isTemp == 'N') {
          if (response.success) {
            snackText.value = 'success'
            snackbar.value = true
            setTimeout(() => utils.movePage('/actionManagement'), 2000);
          } else{
            snackText.value = response.message
            if(snackText.value.includes('message.'))
              snackText.value = t(snackText.value)
            snackbar.value = true
          }
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          if(snackText.value.includes('message.'))
            snackText.value = t(snackText.value)
          snackbar.value = true
        }
      }
    )
  }
}

//임시저장여부, 순서
const onClickTimelineReg=async(isTemp, tempSeq)=> {
  const user = JSON.parse(localStorage.getItem('user'))
  let curItem = _.nth(timelineItems.value, tempSeq-1)

  // 칭찬타입이면서 시정조치여부가 있으면 초기화
  if(curItem.type == '2' && curItem.actionYn == 'Y') {
    curItem.actionYn = 'N'
    curItem.targetType = '1'
    curItem.targetDeptIdx = ''
    curItem.targetMemberIdx = ''
    curItem.goalDate = null
  }
  // 교정타입이면서 교정여부가 없으면 초기화
  if(curItem.type == '1' && curItem.actionYn == 'N'){
    curItem.targetType = '1'
    curItem.targetDeptIdx = ''
    curItem.targetMemberIdx = ''
    curItem.goalDate = null
  }
  //타겟타입이 대상없음이면 대상들 초기화
  if(curItem.targetType == '1'){
    curItem.targetDeptIdx = ''
    curItem.targetMemberIdx = ''
  }

  let params = {
    monitoringIdx: viewIdx,
    memberIdx: user.memberIdx,
    companyIdx: localStorage.getItem('companyIdx'),
    type:curItem.type,
    actionYn: curItem.actionYn,
    goalDate: curItem.goalDate,
    targetType: curItem.targetType,
    targetDeptIdx: curItem.targetDeptIdx,
    targetMemberIdx: curItem.targetMemberIdx,
    behaviorIdx: curItem.behaviorIdx ? curItem.behaviorIdx : '',
    place: curItem.place ? curItem.place : '',
    situation: curItem.situation,
    cause: curItem.cause,
    action: curItem.action,
    isTemp: isTemp,
    tempSeq: tempSeq,
  }

  try{
    const response = await TimelineService.insertTimeline(params)
    utils.log(response.result)
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const confirmCopy=async (type)=>{
  dialogCopyModel.value=false
  let lastObj = _.last(timelineItems.value)
  let tempObj = {}
  if(type == 'confirm') {
    tempObj['companyIdx'] = lastObj.companyIdx
    tempObj['monitoringIdx'] = lastObj.monitoringIdx
    tempObj['answerIdx'] = lastObj.answerIdx
    tempObj['memberIdx'] = lastObj.memberIdx
    tempObj['type'] = lastObj.type
    tempObj['actionYn'] = lastObj.actionYn
    tempObj['targetType'] = lastObj.targetType
    tempObj['targetDeptIdx'] = lastObj.targetDeptIdx
    tempObj['targetMemberIdx'] = lastObj.targetMemberIdx
    tempObj['targetDeptName'] = lastObj.targetDeptName
    tempObj['targetMemberName'] = lastObj.targetMemberName
    tempObj['goalDate'] = lastObj.goalDate
    tempObj['behaviorIdx'] = lastObj.behaviorIdx
    tempObj['place'] = lastObj.place
    tempObj['situation'] = lastObj.situation
    tempObj['cause'] = lastObj.cause
    tempObj['action'] = lastObj.action
    tempObj['delYn'] = lastObj.delYn
    tempObj['isTemp'] = lastObj.isTemp
  }
  else {
    tempObj['answerIdx'] = ''
    tempObj['type'] = '1'
    tempObj['actionYn'] = 'N'
    tempObj['targetType'] = '1'
    tempObj['behaviorIdx'] = selectedBehavior.value ? selectedBehavior.value.idx : ''
    tempObj['place'] = place.value ? place.value : ''
  }
  timelineItems.value.push(tempObj)
  await nextTick()
  panel.value.push(timelineItems.value.length-1)
}

const onInputEtc=(value, index)=>{
  if(value) {
    monitoringItems.value[index].comment = null
  }
}

//타임라인 삭제
const onClickDeleteTimeline=(item)=>{
  if(null == item.idx)
    _.remove(timelineItems.value, item)
  else {
    TimelineService.deleteTimeline({idx: item.idx}).then(
      (response) => {
        _.remove(timelineItems.value, item)
      },
      (error) => {
        if (error.status == 403)
          utils.movePage('/login')
        else {
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

//임시저장 응답 삭제
const deleteTempAnswer=async()=>{
  try {
    const response = BbsService.deleteTempAnswer({monitoringIdx: monitoringInfo.value.idx})
  }
  catch(error){
    if (error.status == 403)
      utils.movePage('/login')
    else {
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//임시저장 타임라인 삭제
const deleteTempTimeline=async()=>{
  try {
    const response = TimelineService.deleteTempTimeline({monitoringIdx: monitoringInfo.value.idx})
  }
  catch(error){
    if (error.status == 403)
      utils.movePage('/login')
    else {
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//임시저장 타임라인 삭제
const deleteTempTimelineImage=async()=>{
  try {
    const response = TimelineService.deleteTempTimelineImage({monitoringIdx: monitoringInfo.value.idx})
  }
  catch(error){
    if (error.status == 403)
      utils.movePage('/login')
    else {
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickAddTimeline=async ()=>{
  if(timelineItems.value.length > 0)
    dialogCopyModel.value=true
}

// watch
watch(tab, async (newTab, oldTab) => {
  if(props.isActive) {
    //선택된 행동 초기화
    if (newTab == 'tabCont1') {
      selectedBehavior.value = null
    } else if (newTab == 'tabCont2') {
      //안전대화 없으면 템플릿 추가
      if (timelineItems.value.length == 0 || selectedBehavior.value) {
        timelineItems.value.push({
          answerIdx: '',
          type: '1',
          actionYn: 'N',
          targetType: '1',
          behaviorIdx: selectedBehavior.value ? selectedBehavior.value.idx : '',
          place: place.value ? place.value : '',
        })
      }
    }
  }
})

watch(() => props.isActive, (val, oldVal) => {
  if (val) {
    if(viewIdx) {
      const user = JSON.parse(localStorage.getItem('user'))
      const companyIdx = localStorage.getItem('companyIdx')
      let params = {
        idx: viewIdx,
        memberIdx: user.memberIdx,
        companyIdx: companyIdx,
        //isTemp: 'Y' -> 중간저장 외 응답한 갯수도 체크필요
      }

      BbsService.getBbsMonitoring(params).then(
        (response) => {
          //모니터링
          monitoringInfo.value = response.result

          //모니터링 진행여부 확인
          const now = dayjs()
          isActiveMonitoring.value = now.isSameOrAfter(dayjs(monitoringInfo.value.startDate)) && now.isSameOrBefore(dayjs(monitoringInfo.value.endDate), 'day') && monitoringInfo.value.periodSeq > 0
          if(!isActiveMonitoring.value)
            return

          //행동
          let monitoringItemArr = []
          behaviorSelectAdd.value = []
          _.forEach(response.result.monitoringBehaviors, (item, key)=> {
            //item['answerData'] = '1'
            if(item.multiYn == 'Y')
              monitoringItemArr.push({...item, comments:[]})
            else
              monitoringItemArr.push({...item, comment:''})
            let tempBehavior = {name:item.behaviorTitle, value:item.idx}
            behaviorSelectAdd.value.push(tempBehavior)
          })
          monitoringItems.value = monitoringItemArr

          //audit타겟수
          auditTargetCnt.value = response.result.auditTargetCnt

          //장소
          placeTab1SelectAdd.value = []
          _.forEach(response.result.monitoringPlaces, (val, key)=> {
            let tempObj = {name:val['place'], value:val['idx']}
            placeTab1SelectAdd.value.push(tempObj)
          })

          //임시저장
          if(monitoringInfo.value.tempYn == 'Y') {
            _.forEach(response.result.monitoringAnswers, (val, key) => {
              if (val.isTemp == 'Y') {
                dialogTempBind.dialogText = t('message.unsavedMonitoringExists') + dayjs(val.regDate).format('YYYY-MM-DD HH:mm:ss')
                dialogTempModel.value = true
              }
            })
          }else{
            //임시저장된 응답이 있으면 삭제
            deleteTempAnswer()
          }

          //타임라인
          if(monitoringInfo.value.tempYn == 'Y') {
            if (response.result.monitoringTimelines.length > 0) {
              timelineItems.value = _.filter(response.result.monitoringTimelines, {isTemp: 'Y'})
              _.forEach(timelineItems.value, (val, key) => {
                val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? null : dayjs(val.goalDate).format('YYYY-MM-DD')
                val.behaviorIdx = val.behaviorIdx==0?'':val.behaviorIdx
              })
            }
          }
          else{
            //임시저장된 타임라인 이미지가 있으면 삭제
            deleteTempTimeline()
            deleteTempTimelineImage()
          }
        },
        (error) => {
          if(error.status == 403)
            utils.movePage('/login')
          else{
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
  }
},{ immediate: true })
</script>


<style lang="scss" >

</style>
